/* eslint-disable */
import { StyleSheet, Dimensions } from 'react-native'
import {Fonts} from '../../Themes'
const postbutton = Dimensions.get('window').width / 5 + 20
const width = (Dimensions.get('window').width -  postbutton) / 4
export default StyleSheet.create({
  container: {
   
    flexDirection: `row`,
    justifyContent: `space-between`,
    alignItems: `flex-end`,
  },
  avatarView : {
    justifyContent: `space-between`,
    paddingTop: 5,
    width: width,
    height: width - 12,
    alignItems: `center`
  },
  iconView : {
    justifyContent: `flex-end`,
  
    width: width,
    height: width - 12,
    alignItems: `center`
  },
 
  icon: {
    width: postbutton / 2.2  - 5,     // was div 3
    height:  postbutton / 2.2  - 5 ,
    marginBottom: 15
  },
  text: {
    fontSize: 10,
    color: `#FFFFFF`,
    fontFamily: Fonts.style.font.regular
  },
  buttonPost:

    { width: postbutton - 15, height: postbutton - 15 },


})
